export default __webpack_public_path__ + "static/media/FailedArt.2eaedc8b.svg";